export const GET_PROCESS_FORM = 'process/process-form-start';
export const GET_PROCESS_ERROR = 'process/process-form-error';
export const PROCESS_CLEAR = 'process/process-form-clear';
export const PROCESS_SINGLE_SUCCESS = 'process/process-single-success';
export const PROCESS_UPDATE_SUCCESS = 'process/process-update-success';
export const PROCESS_CREATE_SUCCESS = 'process/process-create-success';
export const PROCESS_AUDIT = 'process/process-audit';
export const PROCESS_FORM_ADD_PARAMETERS = 'process/process-form-add-parameter';
